"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.array.slice.js");
var _utils = require("../utils");
var _image = _interopRequireDefault(require("../image"));
var _platforms = _interopRequireDefault(require("./platforms"));
var _native;
if (!_utils.isServer) {
  _native = require('@zz-common/native-adapter').default; // eslint-disable-line global-require
}

var _use = (0, _utils.use)('share-panel'),
  sfc = _use[0],
  bem = _use[1];
var _default2 = sfc({
  props: {
    contacts: Array,
    platforms: {
      type: Array,
      default: function _default() {
        return _platforms.default;
      }
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    shouldShowMoreContact: function shouldShowMoreContact() {
      return this.contacts && this.contacts.length > 5;
    }
  },
  methods: {
    onContactsClick: function onContactsClick(item) {
      this.$emit('contact-select', item);
    },
    onShowMoreContact: function onShowMoreContact() {
      this.$emit('show-more-contact');
    },
    onPlatformClick: function onPlatformClick(item) {
      var _this = this;
      if (item.scene && item.type) {
        _native.wrap('baseShare')({
          data: item.data,
          scene: item.scene,
          type: item.type
        }, function (res) {
          console.log(res);
          _this.$emit('platform-select', item, res);
        });
      } else {
        this.$emit('platform-select', item);
      }
    },
    onCationClick: function onCationClick(item) {
      this.$emit('action-select', item);
    }
  },
  render: function render(h) {
    var _this2 = this;
    return h("div", {
      "class": bem()
    }, [this.contacts.length > 0 && h("div", {
      "class": bem('contacts')
    }, [this.contacts.slice(0, this.shouldShowMoreContact ? 4 : undefined).map(function (item) {
      return h("div", {
        "key": item.value,
        "class": bem('item'),
        "on": {
          "click": function click() {
            return _this2.onContactsClick(item);
          }
        }
      }, [h(_image.default, {
        "class": bem('item-logo'),
        "attrs": {
          "fit": "cover",
          "round": true,
          "src": item.logo
        }
      }, [h("div", {
        "slot": "loading"
      })]), h("span", {
        "class": bem('item-title')
      }, [item.title])]);
    }), this.shouldShowMoreContact && h("div", {
      "class": bem('item'),
      "on": {
        "click": function click() {
          return _this2.onShowMoreContact();
        }
      }
    }, [h(_image.default, {
      "class": bem('item-logo'),
      "attrs": {
        "fit": "cover",
        "round": true,
        "src": "1731ccaf-123d-4f94-a998-173e40d9dc62.png"
      }
    }, [h("div", {
      "slot": "loading"
    })]), h("span", {
      "class": bem('item-title')
    }, ["\u66F4\u591A\u8054\u7CFB\u4EBA"])])]), this.platforms.length > 0 && h("div", {
      "class": bem('platforms')
    }, [this.platforms.slice(0, 5).map(function (item) {
      return h("div", {
        "key": item.value,
        "class": bem('item'),
        "on": {
          "click": function click() {
            return _this2.onPlatformClick(item);
          }
        }
      }, [h(_image.default, {
        "class": bem('item-logo'),
        "attrs": {
          "fit": "cover",
          "round": true,
          "src": item.logo
        }
      }, [h("div", {
        "slot": "loading"
      })]), h("span", {
        "class": bem('item-title')
      }, [item.title])]);
    }), this.actions.map(function (item) {
      return h("div", {
        "key": item.value,
        "class": bem('item'),
        "on": {
          "click": function click() {
            return _this2.onCationClick(item);
          }
        }
      }, [h(_image.default, {
        "class": bem('item-logo'),
        "attrs": {
          "fit": "cover",
          "round": true,
          "src": item.logo
        }
      }, [h("div", {
        "slot": "loading"
      })]), h("span", {
        "class": bem('item-title')
      }, [item.title])]);
    })])]);
  }
});
exports.default = _default2;